const styles = theme => ({
  legend: {
    fontWeight: 200,
    // margin: 5,
    textAlign: 'center',
    // marginBottom: 30
    position: 'relative',
    bottom: 30,
    width: '100%',
    marginTop: 10,
  },
  legendItem: {
    fontSize: '14px',
    paddingLeft: '5px',
    paddingRight: '5px'
  }
})

export default styles
